import React from 'react';

import { RadioButton } from '@rbilabs/components-library/build/components/radio-button';
import { useIntl } from 'react-intl';

import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { ServiceMode, useOrderContext } from 'state/order';

import { IPickupServiceModeOptionProps } from './types';

export const PickupServiceModeOption: React.FC<IPickupServiceModeOptionProps> = ({
  serviceMode,
  unavailable,
  header,
  description,
  hidden = false,
}) => {
  const { serviceMode: selectedServiceMode, selectServiceMode } = useOrderContext();
  const { formatMessage } = useIntl();
  const mParticle = useMParticleContext();

  const handleClick = () => {
    if (unavailable) {
      return;
    }

    selectServiceMode(serviceMode);

    const eventName =
      serviceMode === ServiceMode.TABLE_SERVICE
        ? CustomEventNames.BUTTON_CLICK_TABLE_SERVICE
        : CustomEventNames.BUTTON_CLICK_PICKUP;

    mParticle.logEvent(eventName, EventTypes.Other);
  };

  if (hidden) {
    return null;
  }

  const headerText = unavailable ? `${header} (${formatMessage({ id: 'unavailable' })})` : header;

  return (
    <RadioButton
      name="cart-service-mode-selection"
      onChange={handleClick}
      checked={selectedServiceMode === serviceMode}
      disabled={unavailable}
      id={`service-mode-${serviceMode}`}
      labelHeader={headerText}
      label={description}
    />
  );
};
